import ServicesPage from './ServicesPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { disableAlert } from 'store/reducers/alert/actions';
import { cleanAdvisorError } from 'store/reducers/errors/actions';
import {
  addService,
  removeService,
  sendScheduleServiceSelectionShown,
  sendScheduleServiceSelectionFinish
} from 'store/reducers/appointment/actions';
import {
  gtmUserEventTellUsMoreSelected,
  gtmUserEvent
} from 'store/reducers/gtm/actions';

// Selectors
import { getIndividualServices } from 'store/reducers/individualServices/selectors';
import { getRecallServices } from 'store/reducers/recall/selectors';
import { getDeferredServices } from 'store/reducers/deferred/selectors';
import {
  getModel,
  getServicesCount,
  getServicePoint,
  getAppointment,
  vehicleEditableEnabled,
  getVehicle
} from 'store/reducers/appointment/selectors';
import { getServicePackageList } from 'store/reducers/packages/selectors';
import {
  policies,
  getShowMileage
} from 'store/reducers/dealerSettings/selectors';
import { getDeclinedServicesPromotion as getDeclinedServices } from 'store/reducers/declined/selectors';
import {
  getActivePromotion,
  getPromotionGroupByType,
  hasPromotion
} from 'store/reducers/promotions/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import {
  servicesFormOptimizely,
  getCTABanner,
  showProgressBar,
  hideBottomCTA,
  getBackButton
} from 'store/reducers/optimizelyABTest/selectors';
import {
  getModelLabelOther,
  getMakeLabelOther
} from 'store/reducers/userInteractions/selectors';
import { getGlobalRepairServices } from 'store/reducers/globalRepair/selectors';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = state => {
  return {
    servicesCount: getServicesCount(state),
    servicePoint: getServicePoint(state),
    packageList: getServicePackageList(state),
    model: getModel(state),
    individualServices: getIndividualServices(state),
    recallServices: getRecallServices(state),
    policies: policies(state),
    declinedServicesExist:
      getDeclinedServices(state).length > 0 ||
      getDeferredServices(state).length > 0,
    appointment: getAppointment(state),
    promotionGroup: getPromotionGroupByType(state),
    promotion: getActivePromotion(state),
    hasPromotion: hasPromotion(state),
    showMileage: undefinedToTrue(getShowMileage(state)),
    vehicleEditableEnabled: vehicleEditableEnabled(state),
    isLoggedIn: isLoggedIn(state),
    servicesFormOptimizely: servicesFormOptimizely(state),
    modelLabelOther: getModelLabelOther(state),
    makeLabelOther: getMakeLabelOther(state),
    ctaBanner: getCTABanner(state),
    vehicle: getVehicle(state),
    showProgressBar: showProgressBar(state),
    hideBottomCTA: hideBottomCTA(state),
    ctaBackButton: getBackButton(state),
    globalRepairServices: getGlobalRepairServices(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      goTo,
      addService,
      removeService,
      gtmUserEventTellUsMoreSelected,
      disableAlert,
      gtmUserEvent,
      cleanAdvisorError,
      sendScheduleServiceSelectionShown,
      sendScheduleServiceSelectionFinish
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ServicesPage);



// WEBPACK FOOTER //
// ./src/components/pages/ServicesPage/ServicesContainer.js